module.exports = __webpack_public_path__ + "img/9C.32715b1f.png";